
import { defineComponent } from 'vue'

import { UiTooltip } from '../keen-ui'
import { EpbButton } from '../shared'

export default defineComponent({
  name: 'ExplainHeaderDownloadButton',
  components: {
    EpbButton,
    UiTooltip,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
  },
})
